import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const SiteSettingServices = createApi({
	reducerPath: "SiteSettingServices",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			siteSettingUrl: builder.query({
				query: () => {
					return {
						url: `settings/config`,
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useSiteSettingUrlQuery } = SiteSettingServices;
export default SiteSettingServices;
